import { NATIONAL_SECTION_LEGACY_ID } from "@/pages/people/membership-services/committees/constants";
import type { SectionGovernanceTargetType } from "./sectionGovernanceQueries";

export function getSectionGovernanceTargetType(
  section: { name?: string; legacyId?: string | null } | null | undefined
): SectionGovernanceTargetType {
  return section?.legacyId === NATIONAL_SECTION_LEGACY_ID ? "NATIONAL" : "SECTION";
}
